import {
  Radio
} from 'element-ui'

const defaultCellProps = {
  width: 48
}

const renderCell = (h, scope, pagodaTable) => {
  return (
    <Radio
      class="pagoda-table-v2-radio"
      value={ pagodaTable.radioSelectIdx }
      onInput={value => {
        pagodaTable.radioSelectIdx = value
        pagodaTable.radioSelect = scope.row
      }}
      label={ scope.$index }
    ></Radio>
  )
}

export {
  defaultCellProps,
  renderCell
}
